export function PageHeader({ label, title, subtitle, children, bgImage }) {
  return (
    <section className="relative overflow-hidden border-b border-border bg-ztk-navydark pt-[68px] text-white">
      <div className="hero-grid absolute inset-0 opacity-40" />
      <div className="absolute -right-24 top-10 h-72 w-72 rounded-full bg-ztk-blue/20 blur-[100px]" />
      <div className={`relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24 ${bgImage ? "grid items-center gap-12 lg:grid-cols-2" : ""}`}>
        <div className={bgImage ? "animate-fade-up" : ""}>
          {label && <p className="label-mono mb-3 text-ztk-glow">{label}</p>}
          <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">{subtitle}</p>}
          {children}
        </div>
        {bgImage && (
          <div className="animate-fade-up" style={{ animationDelay: "0.15s" }} data-testid="page-hero-image">
            <div className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl">
              <img src={bgImage} alt="" className="h-[340px] w-full object-cover" />
            </div>
          </div>
        )}
      </div>
      <div className="cable-accent h-[3px] w-full" />
    </section>
  );
}
